/* eslint-disable import/no-unresolved */
import { useEffect } from "react";
import { useGetApplicationSettings } from "services/common";
import { appLogout } from "store/auth-context";

const MINUTES_IN_MS = 60 * 1000;
const ACTIVITY_THROTTLE_MS = 1000; // don't broadcast more than once/sec

function IdleManager() {
  const { data: appSettingsRes, mutate: getAppSettings } =
    useGetApplicationSettings();

  useEffect(() => {
    getAppSettings();
  }, [getAppSettings]);

  useEffect(() => {
    if (!appSettingsRes?.data?.sessionTimeout) return undefined;

    const IDLE_TIMEOUT_MINUTES = Number(
      appSettingsRes.data.sessionTimeout || 10
    );
    const IDLE_TIMEOUT = IDLE_TIMEOUT_MINUTES * MINUTES_IN_MS;

    const channel = new BroadcastChannel("activityChannel");
    let timeoutId = null;
    let lastActivity = Date.now();
    let lastBroadcast = 0;

    // eslint-disable-next-line no-console
    console.log(
      new Date(),
      "Idle tracking started. Timeout:",
      IDLE_TIMEOUT_MINUTES,
      "mins"
    );

    const scheduleLogoutCheck = () => {
      if (timeoutId) clearTimeout(timeoutId);
      const remaining = IDLE_TIMEOUT - (Date.now() - lastActivity);
      timeoutId = setTimeout(
        () => {
          if (Date.now() - lastActivity >= IDLE_TIMEOUT) {
            channel.postMessage({ type: "ALL_TABS_IDLE" });
            triggerLogout();
          } else {
            scheduleLogoutCheck(); // activity happened right at the edge, recheck
          }
        },
        Math.max(remaining, 0)
      );
    };

    const triggerLogout = () => {
      if (timeoutId) clearTimeout(timeoutId);
      // eslint-disable-next-line no-console
      console.log(new Date(), "Logout due to Inactivity");
      appLogout();
    };

    const updateActivity = () => {
      const now = Date.now();
      lastActivity = now;
      scheduleLogoutCheck();

      // throttle cross-tab broadcasts
      if (now - lastBroadcast >= ACTIVITY_THROTTLE_MS) {
        lastBroadcast = now;
        channel.postMessage({ type: "USER_ACTIVITY", timestamp: now });
      }
    };

    window.addEventListener("mousemove", updateActivity);
    window.addEventListener("keydown", updateActivity);
    window.addEventListener("click", updateActivity);

    updateActivity(); // initial state + starts the timer

    channel.onmessage = (event) => {
      if (event.data.type === "USER_ACTIVITY") {
        if (event.data.timestamp > lastActivity) {
          lastActivity = event.data.timestamp;
          scheduleLogoutCheck();
        }
      }
      if (event.data.type === "ALL_TABS_IDLE") {
        triggerLogout();
      }
    };

    return () => {
      if (timeoutId) clearTimeout(timeoutId);
      window.removeEventListener("mousemove", updateActivity);
      window.removeEventListener("keydown", updateActivity);
      window.removeEventListener("click", updateActivity);
      channel.close();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [appSettingsRes?.data?.sessionTimeout]);

  return null;
}

export default IdleManager;
